import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {getDefaultColumnsConfigByDef, normalizeColumnsConfig} from '../../../components/tables/table';
import {DEX_DEV_RATES_TABLE_COLUMNS_DEF, DexDevRatesTableColumnConfig} from '../dex-dev-rates-table';
import {DevRatesWidgetSettingsDef, DexDevRatesWidgetSettings} from './dex-dev-rates-widget-settings';

@Injectable()
export class DexDevRatesWidgetSettingsService implements WidgetSettingsService {

    private readonly defaultColumnsSettings: DexDevRatesTableColumnConfig[] =
                         getDefaultColumnsConfigByDef(DEX_DEV_RATES_TABLE_COLUMNS_DEF);

    public getDefaultSettings(): Observable<DexDevRatesWidgetSettings> {
        const defaultWidgetSettings: DexDevRatesWidgetSettings = {
            title:   null,
            columns: this.defaultColumnsSettings.slice()
        };

        return of(defaultWidgetSettings);
    }

    public fromDefinition(settingsDef: DevRatesWidgetSettingsDef): Observable<DexDevRatesWidgetSettings> {
        return of<DexDevRatesWidgetSettings>({
            title:   settingsDef.title,
            columns: settingsDef.columns
                         ? normalizeColumnsConfig(DEX_DEV_RATES_TABLE_COLUMNS_DEF, settingsDef.columns)
                         : this.defaultColumnsSettings.slice()
        });
    }

    public toDefinition(settings: DexDevRatesWidgetSettings): DevRatesWidgetSettingsDef {
        return {
            title:   settings.title,
            columns: settings.columns && settings.columns.slice()
        };
    }

}
